<template>
  <div class="ai-message-bubble ai-message-assistant">
    <div class="ai-message-assistant-content d-flex gap-gd-1 bg-white border border-gray-lighten p-gd-2">
      <div class="ai-message-assistant-header d-flex align-items-center">
        <img :src="require('@assets/images/icon/ai_generate.svg')" style="width: 20px; height: 20px;" class="mr-gd-half">
      </div>
      <div class="ai-loading-dots d-flex align-items-center gap-gd-1">
        <span class="dot bg-gray"></span>
        <span class="dot bg-gray"></span>
        <span class="dot bg-gray"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AIGenerateLoading',
  computed: {
    ...mapGetters({
      languageEngine: 'designIframe/userPreference/languageEngine'
    })
  }
};
</script>

<style lang="scss" scoped>
.ai-message-bubble {
  margin-bottom: 12px;

  .ai-message-assistant-content {
    border-radius: 16px;
    border-top-left-radius: 0;

    .ai-loading-dots {
     .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        animation: aiDotPulse 1.4s ease-in-out infinite;

        &:nth-child(1) { animation-delay: 0s; }
        &:nth-child(2) { animation-delay: 0.2s; }
        &:nth-child(3) { animation-delay: 0.4s; }
      }
    }
  }
  @keyframes aiDotPulse {
    0%, 80%, 100% {
      opacity: 0.3;
      transform: scale(0.8);
    }
    40% {
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>
